export default "__VITE_ASSET__CPgWdaG5__"